import {Auth} from "@/services/Api";
import axios from "axios";

declare const window: any;

export function setupApiInterceptors(router:any) {
    axios.interceptors.response.use((response) => {
        return response;
    }, function (error) {
        if(!error.response) {
            return Promise.reject(error);
        }

        if (error.response.status === 401) {
            Auth.clearUserData();
        } else if(error.response.status === 402) {
            Auth.me(true)
                .then(() => router.push({
                    name: 'Plans'
                }));
        } else if(error.response.status === 503) {
            return router.push('/unavailable');
        } else if(error.response.status === 404) {
            return router.push('/not-found');
        } else {
            console.error('Error on request', error);
        }

        return Promise.reject(error.response);
    });

    axios.interceptors.request.use((config) => {
        if(Auth.currentUser()?.language) {
            config.headers['Accept-Language'] = Auth.currentUser()?.language;
        }

        if(window.country) {
            config.headers['App-Country'] = window.country;
        }

        if(window.locale) {
            config.headers['App-Locale'] = window.locale;
        }

        if(window.appConfig?.dash?.revenue?.id != null) {
            config.headers['App-Revenue'] = window.appConfig.dash.revenue.id;
        }

        if(Auth.getJwt()) {
            config.headers['Authorization'] = 'Bearer ' + Auth.getJwt();
        }

        return config;
    }, (err) => {
        return Promise.reject(err);
    });
}
